// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
  LANG_TOGGLE: '[data-fragment="LangAndCurrencyHandler.languageToggle"]',
  CURR_TOGGLE: '[data-fragment="LangAndCurrencyHandler.currencyToggle"]',
};

class LangAndCurrencyHandler extends WebComponent {
  constructor(props) {
    super(props);
    this.state = {
      langActive: false,
      currActive: false,
    };
    this.handleLangClick = this.handleLangClick.bind(this);
    this.closeLangSwitch = this.closeLangSwitch.bind(this);
  }

  didMount() {
    this.langToggle = this.element.querySelector(fragments.LANG_TOGGLE);
    this.currToggle = this.element.querySelector(fragments.CURR_TOGGLE);
    this.langToggle.addEventListener('click', this.handleLangClick);
    this.currToggle.addEventListener('click', this.handleCurrClick);
    window.addEventListener('click', this.closeLangSwitch);
  }
  handleLangClick = (e) => {
    this.setState({
      langActive: true,
      currActive: false,
    });
    this.langToggle.parentElement.classList.contains('active') ? this.setState({langActive: false }) : false;
  }
  handleCurrClick = (e) => {
    this.setState({
      langActive: false,
      currActive: true,
    });
    this.currToggle.parentElement.classList.contains('active') ? this.setState({currActive: false }) : false;
  }
  closeLangSwitch = (e) => {
    if (!e.target.matches(fragments.LANG_TOGGLE) || !e.target.matches(fragments.CURR_TOGGLE)) {
      this.langToggle.parentElement.classList.contains('active') ? this.setState({langActive: false }) : false;
      this.currToggle.parentElement.classList.contains('active') ? this.setState({currActive: false }) : false;
    }
  }
  willUnMount() {
   // this.langToggle.removeEventListener('click', this.handleLangClick);
   // this.currToggle.removeEventListener('click', this.handleCurrClick);
   // window.removeEventListener('click', this.closeLangSwitch);
  }
  update() {
    const { langActive, currActive } = this.state;
    classNames(this.langToggle.parentElement, { active: langActive });
    classNames(this.currToggle.parentElement, { active: currActive });
  }
}

export default LangAndCurrencyHandler;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/LangAndCurrencyHandler.js